import { Link } from "react-router-dom";

const servicedCities = [
  { name: "Brooklyn Park", path: "/brooklyn-park" },
  { name: "Burnsville", path: "/burnsville" },
  { name: "Crystal", path: "/crystal" },
  { name: "Eden Prairie", path: "/eden-prairie" },
  { name: "Edina", path: "/edina" },
  { name: "Excelsior", path: "/excelsior" },
  { name: "Golden Valley", path: "/golden-valley" },
  { name: "Hopkins", path: "/hopkins" },
  { name: "Maple Grove", path: "/maple-grove" },
  { name: "Minneapolis", path: "/minneapolis" },
  { name: "Minnetonka", path: "/minnetonka" },
  { name: "Mound", path: "/mound" },
  { name: "New Brighton", path: "/new-brighton" },
  { name: "Orono", path: "/orono" },
  { name: "Osseo", path: "/osseo" },
  { name: "Plymouth", path: "/plymouth" },
  { name: "Rockford", path: "/rockford" },
  { name: "St. Louis Park", path: "/st-louis-park" },
  { name: "St. Paul", path: "/st-paul" },
  { name: "Wayzata", path: "/wayzata" },
].sort((a, b) => a.name.localeCompare(b.name));

const ServiceAreasSection = () => {
  return (
    <section className="py-12 md:py-20 bg-white animate-on-scroll opacity-0">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary text-center mb-8 md:mb-12">
          Areas We Service
        </h2>
        <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {servicedCities.map((city) => (
            <Link
              key={city.path}
              to={city.path}
              className="block p-3 md:p-4 bg-white/30 backdrop-blur-md border border-primary/30 rounded-lg text-center hover:bg-primary/10 transition-colors shadow-lg"
            >
              <span className="text-base md:text-lg font-bold text-primary">{city.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
